import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import { LogOut, Sun, Moon, Smartphone, Shield, User as UserIcon } from 'lucide-react';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const { isDark, toggle } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getInitials = (name) => name?.split(' ').map(p => p[0]).join('').slice(0,2).toUpperCase() || '??';

  return (
    <div style={{ maxWidth: 500, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
      {/* User Info Header */}
      <div className="card" style={{ textAlign: 'center', padding: '32px 20px' }}>
        <div style={{ 
          width: 80, height: 80, borderRadius: '50%', background: 'linear-gradient(135deg, var(--accent), var(--purple))',
          margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 28, fontWeight: 800, color: '#fff', boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
        }}>
          {getInitials(user?.name)}
        </div>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: 'var(--text)' }}>{user?.name}</h1>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 4 }}>
          <div className="role-badge" style={{ 
            background: 'var(--accent-muted)', color: 'var(--accent)', 
            padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 
          }}>
            {user?.role?.toUpperCase()}
          </div>
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 8 }}>{user?.email}</div>
      </div>

      <div className="card">
        <div className="card-header"><div className="card-title">App Settings</div></div>
        <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <button className="nav-item" onClick={toggle} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              {isDark ? <Sun size={18} /> : <Moon size={18} />}
              <span style={{ color: 'var(--text)', fontWeight: 600 }}>{isDark ? 'Light Mode' : 'Dark Mode'}</span>
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Switch</div>
          </button>
          
          <div className="divider" style={{ margin: '8px 0' }} />

          <button className="nav-item" onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', color: 'var(--danger)' }}>
            <LogOut size={18} />
            <span style={{ fontWeight: 600 }}>Sign Out</span>
          </button>
        </div>
      </div>

      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, color: 'var(--text-muted)', fontSize: 12 }}>
          <Smartphone size={14} />
          FieldOps-Pro Mobile v1.0.0
        </div>
      </div>
    </div>
  );
}
